import { render, staticRenderFns } from "./TblEventRescue.vue?vue&type=template&id=37475750"
import script from "./TblEventRescue.vue?vue&type=script&lang=js"
export * from "./TblEventRescue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports